import { styled } from 'styled-components'
import { DoubleButtonModal } from '../shared/Modal'

interface Props {
    message: string
    score: number
    handleCancel: () => void
    handleConfirm: () => void
    setScore: React.Dispatch<React.SetStateAction<number>>
}

export function UpdateModal({
    handleCancel,
    handleConfirm,
    message,
    score,
    setScore,
}: Props) {
    return (
        <DoubleButtonModal
            children={
                <ConfirmMessage
                    message={message}
                    score={score}
                    setScore={setScore}
                />
            }
            onCancel={handleCancel}
            onConfrim={handleConfirm}
        />
    )
}

interface ConfirmMessageProps {
    message: string
    score: number
    setScore: React.Dispatch<React.SetStateAction<number>>
}

const ConfirmMessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

function ConfirmMessage({ message, score, setScore }: ConfirmMessageProps) {
    return (
        <ConfirmMessageWrapper>
            <div>{message}</div>
            <input
                type="number"
                value={score}
                min={0}
                max={1}
                onChange={(e) => {
                    const val = parseInt(e.target.value)
                    if (!isNaN(val) && val >= 0 && val <= 1) {
                        setScore(val)
                    }
                }}
            />
        </ConfirmMessageWrapper>
    )
}
